import { render, staticRenderFns } from "./instagram_applicant.vue?vue&type=template&id=66207314&scoped=true"
import script from "./instagram_applicant.vue?vue&type=script&lang=ts"
export * from "./instagram_applicant.vue?vue&type=script&lang=ts"
import style0 from "./instagram_applicant.vue?vue&type=style&index=0&id=66207314&prod&lang=scss"
import style1 from "./instagram_applicant.vue?vue&type=style&index=1&id=66207314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66207314",
  null
  
)

export default component.exports